import moment from "moment";

export const offerToClipboard = (QS, spayterms, setSQSM, setShowSQSM) => {
  const paytermarray = [];
  spayterms.forEach((item) => {
    if (item.payType === "CAD") {
      paytermarray.push(
        item.portion + " " + item.payType + " within " + item.termdays + " days against scanned copy of documents."
      );
    } else if (item.payType === "Credit") {
      paytermarray.push(item.portion + " " + item.payType + " within " + item.termdays + " days from BL date.");
    } else {
      paytermarray.push(item.portion + " " + item.payType + " within " + item.termdays + " after sales confirmation.");
    }
  });
  const paytermstring = paytermarray.join(" and ");

  const htmlOffer = ` <table style="font-family: Arial, sans-serif; border-collapse: collapse; line-height: 1.5; width: 100%;">
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top; width:100px">Product:</td>
        <td style="padding: 4px 8px;">${QS.product}</td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Quantity:</td>
        <td style="padding: 4px 8px;">${QS.quantity} mt +/- 10% at seller’s option</td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Price:</td>
        <td style="padding: 4px 8px;">
          ${QS.salesprice} USD/mt ${QS.sincoterm} ${QS.POD}. Price at sight
        </td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Shipment:</td>
        <td style="padding: 4px 8px;">
          ${moment(QS.shipfrom).format("MMMM D, YYYY")} to ${moment(QS.shipUNTIL).format(
    "MMMM D, YYYY"
  )} shipment from loading port. Shipped in 20’ or 40’ FCL container at Seller’s option.
        </td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Packaging:</td>
        <td style="padding: 4px 8px;">${QS.bagSize} </td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Payment:</td>
        <td style="padding: 4px 8px;">${paytermstring}</td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Origin:</td>
        <td style="padding: 4px 8px;"></td>
      </tr>
      <tr>
        <td style="font-weight: bold; padding: 4px 8px; vertical-align: top;">Others:</td>
        <td style="padding: 4px 8px;">
          Incoterms 2020.<br>
          Other terms as per previous operations and WG GT&C.
        </td>
      </tr>
    </table>`;
  // Create a temporary blob for HTML clipboard
  const blob = new Blob([htmlOffer], { type: "text/html" });
  const data = [new ClipboardItem({ "text/html": blob })];

  navigator.clipboard
    .write(data)
    .then(() => {
      //   alert("✅ Offer copied to clipboard!");
      setSQSM("Offer Copied");
      setShowSQSM((prev) => !prev);
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
      //   alert("❌ Could not copy to clipboard");
    });
};
